export default __webpack_public_path__ + "assets/myanmar-flag.png";